module.exports = __webpack_public_path__ + "static/media/thumbnail3.46dfdda3.png";